<template>
	<div>
		<section id="hero_info">
			<article>
				<div class="main-wraper" v-if="false">
					<img v-if="false" src="/kr/resume/static/renew_img/hero_info.png">
				</div>
				<p class="caption">야기슈 이용방법</p>
			</article>
		</section>
		<section class="info-cream">
			<div class="content-wrapper">
				<article class="info">
					<h2 id="info00"><span>목차</span></h2>
					<ul class="disc">
						<li><a href="#info01">야기슈에서 제공 하는 서비스 </a></li>
						<li><a href="#info02">기본사용법</a></li>
						<li><a href="#info03">스마트폰에 PDF다운로드 저장방법</a></li>
						<li><a href="#info04">입력한 정보저장</a></li>
						<li><a href="#info05">입력중 이력서의 종류를 변경하는 방법</a></li>
						<li><a href="#info06">로그인 안내</a></li>
						<li><a href="#info07">서버 자동저장</a></li>
						<li><a href="#info08">데이터의 백업생성과 복원(가져오기)</a></li>
						<li><a href="#info09">PDF 메일전송 </a></li>
						<li><a href="#info11">권장환경</a></li>
					</ul>
				</article>
			</div>
		</section>
		<section class="info-cream">
			<div class="content-wrapper">
				<h2 id="info01"><span>야기슈에서 제공 하는 서비스 </span></h2>
				<h3 class="info-title">야기슈에서<br class="sp">아래와 같은 서비스를 이용 할 수 있습니다.</h3>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info01.png"
					alt="입력 내용을 브라우저에 자동 저장, 백업 및 복원, PDF로 출력 & 메일 전송, 편의점 인쇄, 이직 상담">
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2 id="info02"><span>기본사용법</span></h2>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info01.png" alt="">
				<div class="mt40"></div>
				<h3 class="info-title">좀더 자세한 사용법</h3>
				<ul class="step">
					<li>
						<p class="step-num"><span>STEP1</span>이력서 작성하기</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info-step01.png">
						<p class="plaintext">"이력서 작성"을 누르면 아래 사진이 표시됩니다.<br> <span class="bold">"입력시작" 버튼을 클릭</span>
							해주세요.</p>
					</li>
					<li>
						<p class="step-num"><span>STEP2</span>기본정보 입력</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info-step02.png">
						<p class="plaintext">이름,생년월일,나이,성별을 입력합니다.<br>다음 행에서는 주소,연락처를 입력 해주세요.</p>
					</li>
					<li>
						<p class="step-num"><span>STEP3</span>증명사진 업로드</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info-step03.png">
						<p class="plaintext"><span class="bold">"사진업로드" 를 클릭</span>하면, 카메라로 촬영할지, 사진 폴더로부터 데이터를 선택할지가
							표시됩니다.</p>
					</li>
					<li>
						<p class="step-num"><span>STEP4</span>학력입력</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info-step04.png">
						<p class="plaintext"><span class="bold">"자동입력" 버튼을 누르면</span> 최종학력선택, 중학교 0년, 고등학교 0년, 재수생등 0년,
							대학교 0년 등을 선택할 수 있습니다.<br></p>
					</li>
					<li>
						<p class="step-num"><span>STEP5</span>나머지 정보의 입력을 진행</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info-step05.png">
						<p class="plaintext">계속해서 정보를 입력 해주세요.<br>
							<span class="bold">"자동 입력"이나"예문에서 추가"의 녹색 버튼을 </span>누르면 표기되는 입력 템플릿 기능을 활용 해주세요.
						</p>
					</li>
					<li>
						<p class="step-num"><span>STEP６</span>다운로드</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info-step06.png">
						<p class="plaintext">수고하셨습니다!로그인하면 완성된 데이터를 저장할 수 있습니다.<br>
							<span class="bold">"다운로드"버튼을 클릭</span>하면, PDF 이력서가 표시됩니다.
						</p>
					</li>
				</ul>
				<div class="mt40"></div>
				<h3 class="info-title">야기슈 사용법 소개</h3>
				<iframe v-if="false" width="560" height="315" src="https://www.youtube.com/embed/OeJnU_F8RX8"
					title="YouTube video player" frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen></iframe>
				<ul class="disc" v-if="false">
					<li>Yagish란？　2:12~</li>
					<li>이력서를 작성해보자!　5:05~
						<p class="plaintext">
							└ 프로필 입력　6:21~<br>
							└ 주소 입력　7:48~<br>
							└ 연락처 입력　8:46~<br>
							└ 증명사진 업로드　9:32~<br>
							└ 면허・자격증 입력　13:08~<br>
							└ 자기PR입력　14:10~<br>
							└ 출근시간이외　14:27~<br>
							└ 본인희망란 입력　14:45~<br>
							└ 이력서 작성일 입력　15:41~<br>
						</p>
					</li>
					<li>편의점에서 인쇄해보자!　17:05~</li>
					<li>인쇄했습니다!(인쇄시 주의사항)　19:40~
						<p class="plaintext">
							└ 로슨・패밀리 마트에서의 인쇄를 권장하고 있습니다.
						</p>
					</li>

					<li>Yagish를 사용해 본 소감　21:10~</li>
				</ul>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2 id="info03"><span>스마트폰에<br class="sp">PDF다운로드 저장방법</span></h2>
				<h3 class="info-title">iphone에서<br class="sp">다운로드 저장하는 경우</h3>
				<ul class="step">
					<li>
						<p class="step-num"><span>STEP1</span>공유하기 버튼클릭</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info-step07.png">
						<p class="plaintext"><span class="bold">"다운로드"버튼을 클릭</span>하고, 이력서의 페이지가 표시되는 것을 확인해 주세요.<br>
							Safari 메뉴바가 열리면<span class="bold">공유버튼을 클릭</span>합니다</p>
					</li>
					<li>
						<p class="step-num"><span>STEP2</span>파일저장클릭</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info-step08.png">
						<p class="plaintext">메뉴가 표시되면<span class="bold">'파일에 저장'을 클릭</span></p>
					</li>
					<li>
						<p class="step-num"><span>STEP3</span>파일 이름을 입력하고 저장</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info-step09.png">
						<p class="plaintext">①의 부분을 클릭하면 파일명을 편집할 수 있습니다.<br>
							②저장공간을<span class="bold">「이 아이폰」</span>으로 합니다.<br>
							③<span class="bold">우측 상단의'저장'클릭</span>하여 완료<br>
							<span class="gray">※icloud에 저장하고 싶으신 분은 "icloud drive"를 선택해 주세요.그 외 다운로드 앱(dropbox, pages등)을
								사용하고 싶은 경우는 해당 앱을 선택해 주세요.</span>
						</p>
					</li>
				</ul>

			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2 id="info04"><span>입력한 정보저장</span></h2>
				<p class="plaintext">
					입력한 정보는 단말기의 브라우저(Safari나 Chrome 등) 이력에 저장되어 브라우저를 닫고 새로 사이트에 접속하여도 계속해서 입력 할 수 있습니다.<br><br>
					<span class="red">
						공용 PC(PC방이나 학교 등 여러 사람이 이용하는 PC)등에서 이용하실 경우, PC내에 남은 데이터를 다른 사람이 볼 수 있는 가능성이 있습니다.당사는 서비스 이용 후
						데이터를 삭제하길 권장하고 있습니다.
					</span>
				</p>
				<div class="mt40"></div>
				<div class="delite">
					<a href="https://rirekisho.yagish.jp/account/delete" class="btn_green">데이터・계정삭제</a>
				</div>
				<p class="plaintext">
					"설정" >> "데이터·계정삭제" >> "브라우저의 데이터를 삭제한다" 에서 브라우저의 이력을 삭제할 수 있습니다.<br>
					<span class="gray">
						・브라우저에서 입력한 내용은 서버에 저장되지 않으므로 본인 이외에는 입력한 내용을 볼 수 없습니다.<br>
						・회원가입(Google 계정으로 로그인)을 하면 브라우저의 이력과 별도로 서버에 정보를 저장할 수 있게 됩니다.기기를 변경 하더라고 데이터 가져오기로 입력정보를 계속해서
						사용 할 수 있습니다.
					</span>
				</p>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2 id="info05"><span>입력중<br class="sp">이력서의 종류를 변경하는 방법</span></h2>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info02.png">
				<p class="plaintext">
					입력 도중 이력서의 종류를 바꾼 경우에는 같은 항목일 경우한하여 입력한 내용이 유지됩니다.<br>
					대신 이력서마다 다른 내용을 저장할 수 없게 되어 있습니다.<br>
					만약 데이터를 저장해 두고 싶은 경우는, "마이 페이지 >백업생성"에서 현 시점의 내용을 수동으로 저장해 두면 필요할 때 그 내용을 복원할 수 있습니다.
				</p>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2 id="info06"><span>로그인 안내</span></h2>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info03.png">
				<p class="plaintext">
					로그인은 우측 상단의 로그인 버튼을 클릭해 주세요.
				</p>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info04.png">
				<p class="plaintext">
					Google 계정이 없는 경우 사전에 Google 계정을 생성해야 합니다.<br><br>
					<a href="https://accounts.google.com/SignUp?hl=ja" target="_blank">Google 계정 작성</a><br>
					<a href="https://support.google.com/accounts/answer/27441?hl=ja" target="_blank">Google 계정헬프</a>
				</p>

			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2 id="info07"><span>서버 자동저장<br class="sp"><span class="min">※로그인시에만</span></span></h2>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info02.png">
				<p class="plaintext">
					로그인(Google 계정으로 로그인)하면 입력내용이 자동저장 됩니다.<br>
					또한 "설정"에서 수동으로 현시점의 내용을 백업하는 것도 가능합니다.<br>
					<span class="gray">※ Google 계정 로그인이 필수 입니다.</span>
				</p>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2 id="info08"><span>데이터의 백업생성과<br class="sp">복원(가져오기) <br class="sp"><span
							class="min">※로그인시에만</span></span></h2>
				<p class="plaintext">
					<span class="red">
						반드시 "백업" 이 필요합니다<br>
						백업을 하지 않으면 다음 로그인 시 백업데이터를 복원할 수 없습니다.</span>
				</p>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info02.png">
				<p class="plaintext">
					"백업"은 로그인 후, 마이 페이지에서<span class="bold">"백업"을 클릭</span>하는 것으로 생성 할 수 있습니다.
				</p>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info05.png">
				<p class="plaintext">
					마이페이지에서 가져오기 하고싶은 백업 파일의<span class="bold">"이력서선택"을 클릭</span>합니다.
				</p>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info06.png">
				<p class="plaintext">
					페이지 하단의 <span class="bold">"복원하기" 버튼을 클릭</span>해주세요.
				</p>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2 id="info09"><span>PDF의 메일전송 <br class="sp"><span class="min">※로그인시에만</span></span></h2>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info07.png">
				<p class="plaintext">
					작성한 PDF는 자신의 Gmail로 전송할 수 있습니다.<br>
					이력서 입력화면의 마지막단계에서 <span class="bold"> "PDF로 메일 보내기" 버튼</span>을 클릭해 주세요.<br>
					<span class="gray">※ Google 계정로그인이 필수 입니다.</span>
				</p>
			</div>
		</section>
		<section class="info-white" v-if="false">
			<div class="content-wrapper">
				<h2 id="info10"><span>편의점 인쇄서비스를<br class="sp">이용하기<br class="sp"><span
							class="min">※로그인시에만</span></span></h2>
				<p class="plaintext">
					가까운 편의점에서 간단하게 인쇄 할 수 있습니다.<br>
					<span class="gray">
						※모든 템플릿을 인쇄 할 수 있습니다.<br>
						※이력서의 증명사진을 컬러로 출력 할 수 있습니다.<br>
						※업무 경력서의 편의점 인쇄는 최대 8 페이지(흑백 A4 양면 4장)까지 지원됩니다.
					</span>
				</p>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info08.png">
				<p class="plaintext">
					다운로드 화면에 있는<span class="bold">"편의점에서 인쇄하가" 버튼을 클릭</span>하면 인쇄내용을 미리보기로 확인 할 수 있습니다.
				</p>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info09.png">
				<p class="plaintext">
					미리보기화면 아래에 있는<span class="bold">"편의점에서 인쇄하기"버튼을 클릭</span>해주세요.
				</p>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info10.png">
				<p class="plaintext">
					인쇄유형을 선택하고 '이용약관에 동의하여 인쇄하기' 버튼을 선택합니다.
				</p>
				<img v-if="false" src="/kr/resume/static/renew_img/img_info11.png">
				<p class="plaintext">
					유효시간이내에 컨텐츠 번호를 지참하여 인쇄하시기 바랍니다.<br>
					인쇄매수 설정, 결제 등은 편의점에서 해주시기 바랍니다.<br>
					<span class="gray">※콘텐츠번호는 유효시간은 발행후 24시간까지 입니다.<br>
						※세븐일레븐이나 멀티복사기로도 인쇄는 가능하나 인쇄방법이 로손, 패밀리마트와 다르니 주의바랍니다. </span><br>
					<a href="https://www.e-printservice.net/shohin/yagish" target="_blank">자세한 사용방법은 이쪽에서</a>

				</p>
			</div>
		</section>
		<section class="info-cream">
			<div class="content-wrapper">
				<h2 id="info11"><span>권장환경</span></h2>
				<p class="plaintext">
					PC, 스마트폰 모두 이용 가능합니다.
					오프라인기능 및 모든 기능을 쾌적하게 사용하기 위해서는 아래 환경을 권장합니다.
				</p>
				<ul class="disc">
					<li>
						Android 스마트폰
						<p class="plaintext">OS: 8.0.0이후,<span class="bold">브라우저: Google Chrome</span></p>
					</li>
					<li>
						iPhone
						<p class="plaintext">OS: 11.3이후,<span class="bold">브라우저: Safari</span></p>
					</li>
					<li>
						Windows
						<p class="plaintext">OS: Windows10、브라우저: Google Chrome</p>
					</li>
					<li>
						Mac
						<p class="plaintext">OS: High Sierra、브라우저: Google Chrome</p>
					</li>
				</ul>
				<p class="plaintext">
					<span class="gray">※지원이 종료된 OS·브라우저(예: Windows XP, Internet Explorer 10 이하 등)에서는 서비스가 정상적으로 동작하지 않을
						가능성이 있습니다.</span>
				</p>
			</div>
		</section>
	</div>
</template>
<style lang="css" src="@/assets/css/renew_info.css"></style>
<script>
export default {
	data: function () {
		return {}
	},
	computed: {},
	methods: {},
	watch: {},
	mounted: function () { }
}
</script>
